import { useLink } from "@made-people/grease-link";
import { WashIcon } from "../../assets/icons/WashGuarantee";
import { useTranslate } from "@made-people/grease-translations";
import { useHundredWashes } from "../../hooks/use-hundred-washes";

export const WashingInstructionsBlock = () => {
  const Link = useLink();
  const translate = useTranslate();
  const { show } = useHundredWashes();

  if (!show) return null;

  return (
    <div className="col-start-1 col-span-6 mb-0 mt-6 lg:my-10 lg:row-start-9 flex gap-8 bg-surface-1 rounded-md p-6 items-center">
      <WashIcon className="min-w-16 lg:min-w-[72px] w-[72px] h-fit" />
      <div className="flex flex-col gap-1">
        <h3 className="text-heading-xs uppercase">
          {translate("100_Washes_Guarantee_Title")}
        </h3>
        <p className="text-body-sm">
          {translate("100_Washes_Guarantee_Paragraph")}
        </p>
        <Link
          href="100-washings-warranty"
          className="text-body-sm underline underline-offset-2 mt-2"
        >
          {translate("100_Washes_Guarantee_Link")}
        </Link>
      </div>
    </div>
  );
};
